<div class="container-fluid reporting-v2-container">
  <!-- Header -->
  <div class="reporting-header bg-white border-bottom py-4 px-4">
    <div class="d-flex align-items-center justify-content-between">
      <div>
        <h1 class="mb-1">Reporting Center</h1>
      </div>
    </div>
  </div>

  <!-- Tab Navigation -->
  <app-page-tabs
    [tabs]="tabs"
    [activeTab]="activeTab()"
    (tabChange)="selectTab($event)"
  ></app-page-tabs>

  <!-- Tab Content -->
  <div class="reporting-content">
    <div class="container-fluid p-4">
      @if (activeTab() === 'dashboard') {
      <app-reporting-dashboard></app-reporting-dashboard>
      } @if (activeTab() === 'generate') {
      <app-reporting-generate
        [userPrimaryOrgType]="userPrimaryOrgType()"
        [organizationId]="organizationId"
        [userId]="userId"
        [userPrimaryOrgId]="userPrimaryOrgId()"
      ></app-reporting-generate>
      } @if (activeTab() === 'scheduled') {
      <app-reporting-scheduled
        (newSchedule)="goToSaveSchedule()"
        [organizationId]="organizationId"
      ></app-reporting-scheduled>
      } @if (activeTab() === 'history') {
      <app-reporting-history
      [organizationId]="organizationId"
      ></app-reporting-history>
      } @if (activeTab() === 'settings') {
      <app-reporting-settings></app-reporting-settings>
      }
    </div>
  </div>
</div>

<!-- Sample Reports Dialog -->
@if (showSampleReportsDialog()) {
<kendo-dialog
  title="Sample Report Types"
  (close)="closeSampleReportsDialog()"
  [width]="900"
  [height]="600"
>
  <div
    class="p-3"
    style="overflow-y: auto; max-height: 450px"
  >
    <p class="text-muted mb-4">
      Browse available report types to understand what information can be included in your custom reports. Each report
      type can be customized with specific date ranges, customers, and data filters.
    </p>

    <div class="row g-3">
      @for (reportType of sampleReportTypes; track reportType.name) {
      <div class="col-md-6">
        <div class="card h-100 sample-report-card">
          <div class="card-body">
            <div class="d-flex align-items-start mb-3">
              <span class="report-icon me-3">{{ reportType.icon }}</span>
              <div class="flex-grow-1">
                <div class="d-flex align-items-center gap-2 mb-1">
                  <h5 class="card-title mb-0">{{ reportType.name }}</h5>
                  @if (reportType.hasSample) {
                  <span class="badge bg-success sample-badge">Sample Available</span>
                  }
                </div>
                <p class="card-text text-muted small mb-0">{{ reportType.description }}</p>
              </div>
            </div>

            <div class="features-list">
              <p class="small mb-2 fw-semibold text-muted">Key Features:</p>
              <ul class="small mb-0">
                @for (feature of reportType.features; track feature) {
                <li>{{ feature }}</li>
                }
              </ul>
            </div>

            @if (reportType.hasSample) {
            <div class="d-flex gap-2 mt-3">
              <button
                kendoButton
                (click)="previewSampleReport(reportType.sampleFile!, reportType.name)"
                class="flex-fill cyflare-btn-primary cyflare-btn-sm"
              >
                👁️ Preview
              </button>
              <button
                kendoButton
                (click)="downloadSampleReport(reportType.sampleFile!, reportType.name)"
                class="flex-fill cyflare-btn-secondary cyflare-btn-sm"
              >
                📥 Download
              </button>
            </div>
            }
          </div>
        </div>
      </div>
      }
    </div>

    <div class="alert alert-info mt-4 mb-0">
      <strong>💡 Tip:</strong>
      Go to the
      <strong>Generate</strong>
      tab to create custom reports using these templates, or visit
      <strong>Scheduled</strong>
      to set up automated report delivery.
    </div>
  </div>

  <kendo-dialog-actions>
    <button
      kendoButton
      class="cyflare-btn-primary"
      (click)="navigateToGenerate(); closeSampleReportsDialog()"
    >
      Go to Generate Tab
    </button>
    <button
      kendoButton
      class="cyflare-btn-secondary"
      (click)="closeSampleReportsDialog()"
    >
      Close
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
}
